module.exports = __webpack_public_path__ + "selwebee_spt_homework-ENGLISH-bbcd8b4c1639e53aa156224b3aa5a31b.png";